"use client";
import React from "react";
import Link from "next/link";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { cn } from "~/utils/fontsConfig";
import { EventImage } from "./EventImage";
import { If } from "../Conditional";
import { FlexibleEventType } from "~/types/EventTypes";

export const EventPreview = ({
    event,
    className,
}: {
    event: FlexibleEventType;
    className?: string;
}) => {
    const eventLink = `/events/${event.slug}`;
    return (
        <Link href={eventLink}>
            <div
                className={cn(
                    "flex flex-shrink-0 flex-row items-start gap-4 rounded-lg p-4",
                    className,
                )}
            >
                <div className="max-h-[122px] max-w-[136px] flex-shrink-0 overflow-hidden rounded-lg">
                    <EventImage
                        isReadonly={true}
                        event={event as any}
                        options={{ type: "contain" }}
                        allowAnimations={true}
                    />
                </div>
                <div className="flex flex-col">
                    <h3 className="text-lg font-semibold text-v3-N100">
                        {event.name}
                    </h3>
                    <If condition={!!event?.startTime}>
                        <div className="flex items-center gap-2 text-sm text-v3-N300">
                            <FaCalendarAlt />
                            <span>
                                {event?.startTime?.toLocaleDateString()}
                            </span>
                        </div>
                    </If>
                    <div className="flex items-center gap-2 text-sm text-v3-N300">
                        <FaMapMarkerAlt />
                        <span>{event.country}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
};
